export default __webpack_public_path__ + "static/media/reports.845a6131.svg";